export default {
  namespaced: true,
  state: {
    isMobile: false,
    theme: 'light',
    layout: 'head',
    systemName: '业务中台',
    copyright: '2019 上海信医科技有限公司',
    footerLinks: [
      { link: 'http://www.simmed.cn', name: '信医科技' },
      { link: 'http://chain.simmed.cn', name: '信医链' }
    ],
    multipage: false,
    MenuList: JSON.parse(localStorage.getItem('menuList') || '{}'),
    lastMenu: localStorage.getItem('lastMenu') || ''
  },
  mutations: {
    setDevice(state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme(state, theme) {
      state.theme = theme
    },
    setLayout(state, layout) {
      state.layout = layout
    },
    setMultipage(state, multipage) {
      state.multipage = multipage
    },
    setMenuList(state, menuList) {
      localStorage.setItem('menuList', JSON.stringify(menuList));
      state.MenuList = menuList;
    },
    setLastMenu(state, lastMenu) {
      localStorage.setItem('lastMenu', lastMenu);
      state.lastMenu = lastMenu;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js